import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { FaComments } from "react-icons/fa";
import { Translate, I18n } from "react-redux-i18n";

import "./styles/DropDownNotification.css";
import "./styles/DropDownChat.css";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";

import * as actions from "../redux/actions/chatActions";
import UserAvatar from "./UserAvatar";
import * as actions_contacts from "../redux/actions/contactsActions";
import * as actions_message from "../redux/actions/messageActions";
import * as actions_event from "../redux/actions/eventActions";

import MiniLoader from "./MiniLoader";

function getInitials(name, lastName) {
  const first = (name || "").charAt(0);
  const last = (lastName || "").charAt(0);
  return `${first}${last}`.toUpperCase();
}

function DropDownChatItem({ item, onClick }) {
  const preview = item.Message?.Text || "";
  const timestamp = item.Message?.CreatedAt || "";

  return (
    <li className="dropdown-chat-item">
      <Link
        className="dropdown-chat-item__link"
        to={`/chat/${item.ConversationId}`}
        onClick={onClick}
      >
        <UserAvatar
          src={item.Avatar}
          alt=""
          verified={item.Verified}
          user={item}
          size="sm"
          imgClassName="dropdown-chat-item__avatar"
          initials={getInitials(item.Name, item.LastN)}
        />
        <div className="dropdown-chat-item__body">
          <div className="dropdown-chat-item__top">
            <span className="dropdown-chat-item__name">
              {item.Name} {item.LastN}
            </span>
            {timestamp && (
              <span className="dropdown-chat-item__time">{timestamp}</span>
            )}
          </div>
          <div className="dropdown-chat-item__bottom">
            <span className="dropdown-chat-item__preview">{preview}</span>
            {item.MessageCount > 0 && (
              <span className="dropdown-chat-item__badge">
                {item.MessageCount}
              </span>
            )}
          </div>
        </div>
      </Link>
    </li>
  );
}

class DropDownChat extends React.Component {
  state = {
    displayMenu: false,
  };

  wrapperRef = React.createRef();

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (
      this.wrapperRef.current &&
      !this.wrapperRef.current.contains(event.target)
    ) {
      this.setState({ displayMenu: false });
    }
  };

  closeMenu = () => {
    this.setState({ displayMenu: false });
  };

  fetchChatList = async () => {
    try {
      await this.props
        .LoadChat(this.props.user_id, this.props.token)
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  changeDropdownMenu(event) {
    event.preventDefault();
    event.stopPropagation();
    const willOpen = !this.state.displayMenu;
    this.setState({ displayMenu: willOpen }, () => {
      if (willOpen) {
        this.fetchChatList();
      }
    });
  }

  onClickViewChat = (item) => {
    this.closeMenu();
    this.props.SetContact(item);
    this.props.SetContactMessage(item);
    this.props.SetContactEvent(item);
    this.props.ClearBadgetContact(item);
  };

  render() {
    const { chatList, loading, chatCount } = this.props;
    const hasChats = chatList && chatList.length > 0;

    return (
      <div className="dropdown_notification dropdown-chat" ref={this.wrapperRef}>
        <button
          type="button"
          className="button"
          id="dropdown_chat"
          onClick={this.changeDropdownMenu.bind(this)}
          aria-expanded={this.state.displayMenu}
          aria-haspopup="true"
          aria-label={I18n.t("chat_title")}
        >
          <FaComments />
          {chatCount > 0 && <span className="badge">{chatCount}</span>}
        </button>

        {this.state.displayMenu && (
          <div className="dropdown-chat-panel" role="menu">
            <div className="dropdown-chat-panel__header">
              <div>
                <h3 className="dropdown-chat-panel__title">
                  <Translate value="chat_title" />
                </h3>
                {chatCount > 0 && (
                  <p className="dropdown-chat-panel__subtitle">
                    {chatCount} <Translate value="contact_title" />
                  </p>
                )}
              </div>
            </div>

            <div className="dropdown-chat-panel__list">
              {loading ? (
                <div className="dropdown-chat-panel__loading">
                  <MiniLoader />
                </div>
              ) : hasChats ? (
                <ul className="dropdown-chat-panel__items">
                  {chatList.map((item) => (
                    <DropDownChatItem
                      key={item.Id}
                      item={item}
                      onClick={() => {
                        this.onClickViewChat(item);
                      }}
                    />
                  ))}
                </ul>
              ) : (
                <div className="dropdown-chat-panel__empty">
                  <Translate value="contact_not_list" />
                </div>
              )}
            </div>

            <div className="dropdown-chat-panel__footer">
              <Link
                className="dropdown-chat-panel__footer-link"
                to="/contacts/"
                onClick={this.closeMenu}
              >
                <Translate value="notification_see_all" />
              </Link>
            </div>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    user: reducer.session.auth,
    chatCount: reducer.contacts.tab_badget_chat,
    chatList: reducer.chat.list,
    error: reducer.chat.error,
    loading: reducer.chat.loading,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadChat: (user_id, token) =>
    dispatch(actions.loadList({ user_id, token })),
  SetContact: (item) => dispatch(actions_contacts.setContact(item)),
  ClearBadgetContact: (item) =>
    dispatch(actions_contacts.clearBadgetContact({ item })),
  SetContactMessage: (item) =>
    dispatch(actions_message.setContactMessage(item)),
  SetContactEvent: (item) => dispatch(actions_event.setContactEvent(item)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DropDownChat);
